import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import YTable from '@/views/components/table/index.vue';
import { listDealerUserManufacturer, findDealerUserManu } from '@/api/manufacturer.js';
import { listDealerUserAddress } from '@/api/address.js';
import { listSpecs, parseBarCode } from '@/api/product.js';
import { listReportOrderDetail } from '@/api/report.js';
import { findSellOrder, createSellOrder, updateSellOrder, updateSellOrderState, deleteSellOrder, listSellOrderDetail, findSellOrderDetail, createSellOrderDetails, updateSellOrderDetail, deleteSellOrderDetail } from '@/api/order.js';
import AddressComponent from '@/views/base/address/components/form/index.vue';
import ProductComponent from '../components/product/specs.vue';
import { mapActions } from 'vuex';
import PrintComponent from './components/print/index.vue';
import PrintOutComponent from './components/print/stockout.vue';
import ImportComponent from './components/import/excel.vue';
import { listStockOutOrder, listStockDetail } from '@/api/stock.js';
import dayjs from 'dayjs';
export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  components: {
    YTable: YTable,
    AddressComponent: AddressComponent,
    ProductComponent: ProductComponent,
    PrintComponent: PrintComponent,
    PrintOutComponent: PrintOutComponent,
    ImportComponent: ImportComponent
  },
  data: function data() {
    return {
      formLoading: false,
      form: {
        id: null,
        state: 8,
        contactInfo: null,
        distributorId: null,
        receiveAddress: null,
        receiveName: null,
        remarks: null
      },
      formRules: {
        distributorId: [{
          required: true,
          message: '请选择经销商',
          trigger: ['change', 'blur']
        }],
        receiveAddress: [{
          required: true,
          message: '请选择收货地址',
          trigger: ['change', 'blur']
        }],
        subsidiaryName: [{
          required: true,
          message: '请选择供应商',
          trigger: ['change', 'blur']
        }]
      },
      detailRowIndex: -1,
      detailLoading: false,
      detailList: [],
      // 订单产品列表
      manufacturerList: [],
      // 经销商列表
      scanBoxDisplay: false,
      // 扫码框显示状态
      scanBarCode: null,
      // 扫码值
      tipMessage: null,
      // 提示信息
      detailForm: {
        page: 1,
        pageSize: 10,
        total: 0,
        sellOrderId: null
      },
      addressList: [],
      orderRow: {
        organization: {
          name: null
        }
      },
      tabActiveId: 1,
      timestamp: new Date().valueOf(),
      stockForm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      stockoutList: [],
      stockoutStatusList: [{
        ID: null,
        name: '全部',
        type: 'default'
      }, {
        ID: 1,
        name: '暂存',
        type: 'default'
      }, {
        ID: 2,
        name: '已提交',
        type: 'primary'
      }, {
        ID: 4,
        name: '已出库',
        type: 'primary'
      }, {
        ID: 5,
        name: '作废',
        type: 'danger'
      }, {
        ID: 6,
        name: '确认收货',
        type: 'success'
      }],
      subsidiaryList: [],
      expandedRows: [],
      selectionRows: [],
      isDisplayPrice: 2 // 是否显示价格，1=显示  2=不显示

    };
  },
  created: function created() {
    this.detailTableCacheName = 'SC-' + this.$route.name + '-detail-table';
    this.detailColumns = [{
      label: '产品编号',
      prop: 'productNumber',
      checked: true,
      width: 150
    }, {
      label: '产品名称',
      prop: 'productName',
      checked: true,
      width: 150
    }, {
      label: '规格型号',
      prop: 'specificationModel',
      checked: true,
      width: 200
    }, {
      label: '单位',
      prop: 'unit',
      checked: true,
      width: 100
    }, {
      label: '数量',
      prop: 'sellQuantity',
      checked: true,
      width: 150,
      fixedWidth: true,
      slot: 'sellQuantity'
    }, {
      label: '单价',
      prop: 'sellUnitPrice',
      checked: true,
      width: 100,
      formatter: function formatter(val) {
        return Number(val).toFixed(2);
      }
    }, {
      label: '价格',
      prop: 'sellAmount',
      checked: true,
      width: 100,
      formatter: function formatter(val) {
        return Number(val).toFixed(2);
      }
    }, {
      label: '注册/备案证',
      prop: 'registrationNumber',
      checked: true,
      width: 200
    }, {
      label: '厂家',
      prop: 'manufacturer',
      checked: true,
      width: 200
    }, {
      label: '通用名称',
      prop: 'genericName',
      checked: true,
      width: 120,
      fixedWidth: true
    }];
    this.deliveryColumns = [{
      label: '出库单号',
      prop: 'deliveryOrderNo',
      checked: true,
      width: 150,
      fixedWidth: true
    }, {
      label: '产品编号',
      prop: 'productNumber',
      checked: true,
      width: 150,
      fixedWidth: true
    }, {
      label: '产品名称',
      prop: 'productName',
      checked: true,
      width: 150
    }, {
      label: '规格型号',
      prop: 'specificationModel',
      checked: true,
      width: 200,
      fixedWidth: true
    }, {
      label: '单位',
      prop: 'unit',
      checked: true,
      width: 100
    }, {
      label: '批号',
      prop: 'batchNumber',
      checked: true,
      width: 100
    }, {
      label: '序列号',
      prop: 'trackingCode',
      checked: true,
      width: 100
    }, {
      label: '数量',
      prop: 'deliveryQuantity',
      checked: true,
      width: 150
    }, {
      label: '生产日期',
      prop: 'manufacturerDate',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '有效期',
      prop: 'validityDate',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '灭菌批号',
      prop: 'sterilizationBatchNumber',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '灭菌效期',
      prop: 'sterilizationDate',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '注册/备案证',
      prop: 'registrationNumber',
      checked: true,
      width: 200
    }, {
      label: '厂家',
      prop: 'manufacturer',
      checked: true,
      width: 200
    }, {
      label: '通用名称',
      prop: 'genericName',
      checked: true,
      width: 120,
      fixedWidth: true
    }];
  },
  mounted: function mounted() {
    this.init();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, db, findRow;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.detailRowIndex = -1;
                that.loading = false;
                _context.next = 5;
                return _this.database({
                  user: true
                });

              case 5:
                db = _context.sent;
                that.profile = db.get('profile').value();
                that.formLoading = false;

                if (Number(that.id)) {
                  that.formEdit();
                } else {
                  that.formAdd();
                }

                _context.next = 11;
                return that.loadManufacturer();

              case 11:
                _context.next = 13;
                return that.loadAddress();

              case 13:
                that.subsidiaryList = [];

                if (that.form.distributorId) {
                  findRow = that.manufacturerList.find(function (item) {
                    return item.ID === that.form.distributorId;
                  });
                  that.subsidiaryList = findRow.subsidiarys ? findRow.subsidiarys : [];
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadDealerUserManu: function loadDealerUserManu() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;

                if (!that.form.distributorId) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return findDealerUserManu({
                  manuId: that.form.distributorId
                }).then(function (res) {
                  that.isDisplayPrice = res.redealerUser.isDisplayPrice || 2;
                }).catch(function (e) {
                  console.log(e.message);
                });

              case 4:
                _context2.next = 7;
                break;

              case 6:
                that.isDisplayPrice = 2;

              case 7:
                // 判断isDisplayPrice，处理表格字段
                if (that.isDisplayPrice === 1) {
                  that.detailColumns.forEach(function (row, index) {
                    if (['单价', '价格'].includes(row.label)) {
                      that.detailColumns[index].hide = false;
                      console.log('显示单价和价格');
                    }
                  });
                } else {
                  that.detailColumns.forEach(function (row, index) {
                    if (['单价', '价格'].includes(row.label)) {
                      that.detailColumns[index].hide = true;
                      console.log('隐藏单价和价格');
                    }
                  });
                }

                that.timestamp = new Date().valueOf();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    formAdd: function formAdd() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, distributorId, loading, batchReplenishmentIds, query, specificationModelList, specificationModels, addList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.form = {
                  id: null,
                  state: 8,
                  contactInfo: null,
                  distributorId: null,
                  receiveAddressId: null,
                  receiveAddress: null,
                  receiveName: null,
                  remarks: null,
                  subsidiaryName: null
                };
                that.orderRow.organization.name = that.$store.state.d2admin.user.info.organizationName;

                if (!that.$route.params.batchReplenishmentIds) {
                  _context3.next = 29;
                  break;
                }

                if (!(that.$route.params.batchReplenishmentIds.length > 0)) {
                  _context3.next = 29;
                  break;
                }

                distributorId = that.$route.params.distributorId;
                that.detailList = [];
                loading = _this3.$loading({
                  text: '订单创建中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context3.prev = 8;
                batchReplenishmentIds = that.$route.params.batchReplenishmentIds;
                query = {
                  deliveryIds: batchReplenishmentIds,
                  page: 1,
                  pageSize: 9999
                };
                specificationModelList = [];
                _context3.next = 14;
                return listReportOrderDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    var findRow = specificationModelList.find(function (item) {
                      return item.specificationModel === row.specs.specificationModel && item.inventoryId === row.inventoryId && item.batchNumber === row.inventory.batch_number;
                    });

                    if (!findRow) {
                      specificationModelList.push({
                        specificationModel: row.specs.specificationModel,
                        sellQuantity: row.deliveryQuantity,
                        mainId: row.mainId,
                        specsId: row.specsId,
                        inventoryId: row.inventoryId,
                        batchNumber: row.inventory.batch_number,
                        trackingCode: row.inventory.trackingCode,
                        distributorId: distributorId
                      });
                    } else {
                      findRow.sellQuantity += row.deliveryQuantity;
                    }
                  });
                });

              case 14:
                specificationModels = [];
                specificationModelList.map(function (item) {
                  if (!specificationModels.includes(item.specificationModel)) {
                    specificationModels.push(item.specificationModel);
                  }
                });
                addList = [];

                if (!(specificationModelList.length > 0)) {
                  _context3.next = 24;
                  break;
                }

                that.form.distributorId = specificationModelList[0].distributorId;
                that.distributorIdChange();
                _context3.next = 22;
                return listSpecs({
                  specificationModels: specificationModels,
                  page: 1,
                  pageSize: 9999,
                  manufacturerId4: specificationModelList[0].distributorId
                }).then(function (res) {
                  // 遍历数据,与 specificationModelList 匹配相关联的数据
                  specificationModelList.map(function (row) {
                    console.log(row.mainId, row.specsId);
                    var findRow = res.list.find(function (item) {
                      return item.specificationModel === row.specificationModel && item.mainId === row.mainId && item.ID === row.specsId;
                    });
                    console.log('没找到', findRow, row);

                    if (findRow) {
                      addList.push({
                        ID: null,
                        specsId: findRow.ID,
                        mainId: findRow.mainId,
                        sellQuantity: row.sellQuantity,
                        // 数量
                        sellUnitPrice: findRow.sellUnitPrice,
                        sellAmount: 0,
                        remarks: null,
                        productName: findRow.main.productName,
                        brandName: findRow.main.brandName,
                        registrationNumber: findRow.main.registrationNumber,
                        manufacturer: findRow.main.manufacturer,
                        productNumber: findRow.productNumber || null,
                        barCode: findRow.barCode || null,
                        specificationModel: findRow.specificationModel || null,
                        unit: findRow.unit || null,
                        wholesalePurchasePrice: findRow.wholesalePurchasePrice || 0,
                        consignmentPurchasePrice: findRow.consignmentPurchasePrice || 0,
                        marketPrice: findRow.marketPrice || 0,
                        consignmentPrice: findRow.consignmentPrice || 0,
                        wholesalePrice: findRow.wholesalePrice || 0,
                        onlPrice: findRow.onlPrice || 0,
                        lowPrice: findRow.lowPrice || 0,
                        checked: false,
                        genericName: row.specs.genericName
                      });
                    }
                  });
                });

              case 22:
                addList.map(function (item) {
                  item.sellUnitPrice = Number(item.wholesalePrice);
                  item.sellAmount = Number(Number(item.wholesalePrice) * Number(item.sellQuantity)).toFixed(2);
                  item.sellAmount = Number(item.sellAmount);
                });
                that.addProductToDetailList(addList);

              case 24:
                _context3.next = 28;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](8);

              case 28:
                loading.close();

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[8, 26]]);
      }))();
    },
    formEdit: function formEdit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, row, form;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                form = {
                  id: Number(that.id) || that.form.id
                };
                _context4.next = 4;
                return findSellOrder(form).then(function (res) {
                  row = res.resellOrder;
                  that.orderRow = row;
                  that.form = {
                    id: row.ID,
                    state: row.state,
                    contactInfo: row.contactInfo,
                    distributorId: row.distributorId || null,
                    receiveAddressId: row.receiveAddressId || null,
                    receiveAddress: row.receiveAddress,
                    receiveName: row.receiveName,
                    remarks: row.remarks,
                    subsidiaryName: row.subsidiaryName || that.$store.state.d2admin.user.info.organizationName
                  };

                  if (that.form.state === 9) {
                    that.form.state = 8;
                  }
                }).catch(function (e) {});

              case 4:
                _context4.next = 6;
                return that.loadDealerUserManu();

              case 6:
                _context4.next = 8;
                return that.loadDetail();

              case 8:
                if (that.action === 'RECEIVE') {
                  that.tabChange(2);
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, query, _query;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;

                if (that.form.id) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                that.detailList = [];
                that.detailLoading = true;

                if (!(that.tabActiveId === 1)) {
                  _context5.next = 11;
                  break;
                }

                query = {
                  sellOrderId: that.form.id,
                  page: that.detailForm.page,
                  pageSize: that.detailForm.pageSize
                };
                _context5.next = 9;
                return listSellOrderDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      specsId: row.specsId,
                      mainId: row.mainId,
                      sellQuantity: row.sellQuantity,
                      sellUnitPrice: row.sellUnitPrice,
                      sellAmount: row.sellAmount,
                      remarks: row.remarks,
                      productName: row.main.productName,
                      brandName: row.main.brandName,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      productNumber: row.specs.productNumber,
                      barCode: row.specs.barCode,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      genericName: row.specs.genericName
                    });
                  });
                  console.log('that.detailList', that.detailList);
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.dataTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {
                  console.log(e.message);
                });

              case 9:
                _context5.next = 15;
                break;

              case 11:
                if (!(that.tabActiveId === 2)) {
                  _context5.next = 15;
                  break;
                }

                _query = {
                  sellOrderId: that.form.id,
                  page: that.detailForm.page,
                  pageSize: that.detailForm.pageSize,
                  deliveryStatus: 6,
                  deliveryIssueType: 5
                };
                _context5.next = 15;
                return listStockDetail(_query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      specsId: row.specsId,
                      mainId: row.mainId,
                      deliveryQuantity: row.deliveryQuantity,
                      remarks: row.remarks,
                      productName: row.main.productName,
                      brandName: row.main.brandName,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      productNumber: row.specs.productNumber,
                      barCode: row.specs.barCode,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      batchNumber: row.stockMain.batch_number,
                      trackingCode: row.stockMain.trackingCode,
                      manufacturerDate: row.stockMain.manufacturer_date,
                      validityDate: row.stockMain.validity_date,
                      sterilizationBatchNumber: row.stockMain.sterilization_batch_number,
                      sterilizationDate: row.stockMain.sterilization_date,
                      deliveryOrderNo: row.stockout.deliveryOrderNo,
                      genericName: row.specs.genericName
                    });
                  });
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.dataTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 15:
                that.detailLoading = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadManufacturer: function loadManufacturer() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context6.next = 4;
                return listDealerUserManufacturer(query).then(function (res) {
                  that.manufacturerList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    loadAddress: function loadAddress() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;
                that.addressList = [];
                query = {
                  page: 1,
                  pageSize: 9999,
                  manuId: that.form.distributorId
                };
                _context7.next = 5;
                return listDealerUserAddress(query).then(function (res) {
                  that.addressList = res.list;
                }).catch(function (e) {});

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    excelImport: function excelImport() {
      var that = this;
      that.$refs.ImportComponentRef.init({
        distributorId: that.form.distributorId
      });
    },
    quantitySum: function quantitySum() {
      var that = this;
      var num = 0;

      if (that.tabActiveId === 1) {
        that.detailList.map(function (item) {
          num += item.sellQuantity;
        });
      } else if (that.tabActiveId === 2) {
        that.stockoutList.map(function (item) {
          item.stockoutInfo.map(function (item2) {
            num += item2.deliveryQuantity;
          });
        });
      }

      return num;
    },
    amountSum: function amountSum() {
      var that = this;
      var amount = 0;
      that.detailList.map(function (item) {
        amount += Number(item.sellAmount);
      });
      return Number(amount).toFixed(2);
    },
    scanBoxDisplaySwitch: function scanBoxDisplaySwitch() {
      var that = this;
      that.scanBoxDisplay = !that.scanBoxDisplay;

      if (that.scanBoxDisplay) {
        that.$nextTick(function () {
          that.$refs.scanInputBoxRef.focus();
        });
      }
    },
    barCodeSearch: function barCodeSearch() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that, query, parseRes, specsQuery;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this8;

                if (!that.scanBarCode) {
                  _context9.next = 16;
                  break;
                }

                if (!(that.scanBarCode.substr(0, 2) === '01')) {
                  _context9.next = 13;
                  break;
                }

                query = {
                  di: null,
                  dipi: null
                };

                if (that.scanBarCode.length > 20) {
                  query.dipi = that.scanBarCode;
                } else {
                  query.di = that.scanBarCode;
                }

                _context9.next = 7;
                return parseBarCode(query);

              case 7:
                parseRes = _context9.sent;
                specsQuery = {
                  barCode: parseRes.barCode,
                  page: 1,
                  pageSize: 1
                };
                _context9.next = 11;
                return listSpecs(specsQuery).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(res) {
                    var rows;
                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!(res.total === 1)) {
                              _context8.next = 9;
                              break;
                            }

                            rows = [];
                            res.list.map(function (row) {
                              rows.push({
                                ID: null,
                                specsId: row.ID,
                                mainId: row.mainId,
                                sellQuantity: 1,
                                sellUnitPrice: row.wholesalePrice,
                                sellAmount: row.wholesalePrice * 1,
                                remarks: null,
                                productName: row.main.productName,
                                brandName: row.main.brandName,
                                registrationNumber: row.main.registrationNumber,
                                manufacturer: row.main.manufacturer,
                                productNumber: row.productNumber || null,
                                barCode: row.barCode || null,
                                specificationModel: row.specificationModel || null,
                                unit: row.unit || null,
                                wholesalePurchasePrice: row.wholesalePurchasePrice || 0,
                                consignmentPurchasePrice: row.consignmentPurchasePrice || 0,
                                marketPrice: row.marketPrice || 0,
                                consignmentPrice: row.consignmentPrice || 0,
                                wholesalePrice: row.wholesalePrice || 0,
                                onlPrice: row.onlPrice || 0,
                                lowPrice: row.lowPrice || 0,
                                checked: false,
                                genericName: row.genericName
                              });
                            });
                            _context8.next = 5;
                            return that.addProductToDetailList(rows);

                          case 5:
                            that.scanBarCode = null;
                            that.tipMessage = '产品名称：' + rows[0].productName + '，规格型号：' + rows[0].specificationModel;
                            _context8.next = 10;
                            break;

                          case 9:
                            if (res.total === 0) {
                              that.$message.error('未找到相关产品：' + that.scanBarCode);
                            } else if (res.total > 1) {
                              that.$refs.ProductComponentRef.init({
                                distributorId: that.form.distributorId,
                                barCode: that.scanBarCode,
                                consignmentPriceShow: false
                              });
                            }

                          case 10:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 11:
                _context9.next = 16;
                break;

              case 13:
                that.scanBarCode = '01' + that.scanBarCode;
                _context9.next = 16;
                return that.barCodeSearch();

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    orderPrint: function orderPrint() {
      var that = this;
      that.$refs.PrintComponentRef.init(that.form.id);
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page; // if (that.detailRowIndex >= 0) {
      //   let pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize)
      //   if (that.detailRowIndex > pageRows.length - 1) {
      //     that.detailRowIndex = pageRows.length - 1
      //   }
      //   let row = pageRows[that.detailRowIndex]
      //   that.$refs.dataTableRef.setCurrentRow(row, true)
      // }

      that.loadDetail();
    },
    detailRowClick: function detailRowClick(row, column, event) {
      var that = this; // let pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize)

      var index = that.detailList.indexOf(row);

      if (index >= 0) {
        that.detailRowIndex = index;
      } else {
        that.detailRowIndex = -1;
      }
    },
    newAddress: function newAddress() {
      var that = this;
      var row = {
        id: null,
        manuId: that.form.distributorId
      };
      that.$refs.AddressComponentRef.init(row);
    },
    formStorage: function formStorage() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this9;
                return _context11.abrupt("return", new Promise(function (resolve, reject) {
                  that.$refs.form.validate( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(valid, err) {
                      var loading, form, findRow, res, item;
                      return regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              if (!valid) {
                                _context10.next = 30;
                                break;
                              }

                              loading = _this9.$loading({
                                text: '订单暂存中...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                              });
                              _context10.prev = 2;
                              form = JSON.parse(JSON.stringify(that.form));
                              findRow = that.addressList.find(function (item) {
                                return item.ID === form.receiveAddressId;
                              });

                              if (findRow) {
                                form.receiveAddress = findRow.address;
                              } else {
                                form.receiveAddress = null;
                                form.receiveName = null;
                                form.contactInfo = null;
                              }

                              if (!form.id) {
                                _context10.next = 11;
                                break;
                              }

                              _context10.next = 9;
                              return updateSellOrder(form);

                            case 9:
                              _context10.next = 15;
                              break;

                            case 11:
                              _context10.next = 13;
                              return createSellOrder(form);

                            case 13:
                              res = _context10.sent;
                              that.form.id = res.ID;

                            case 15:
                              _context10.next = 17;
                              return that.productSaveAll();

                            case 17:
                              if (form.id) {
                                _context10.next = 20;
                                break;
                              }

                              _context10.next = 20;
                              return that.loadDetail();

                            case 20:
                              that.$notify.success('暂存成功');
                              resolve();
                              _context10.next = 27;
                              break;

                            case 24:
                              _context10.prev = 24;
                              _context10.t0 = _context10["catch"](2);
                              console.log(_context10.t0.message);

                            case 27:
                              loading.close();
                              _context10.next = 32;
                              break;

                            case 30:
                              item = err[Object.keys(err)[0]][0];
                              reject(new Error(item.message));

                            case 32:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10, null, [[2, 24]]);
                    }));

                    return function (_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    formSubmit: function formSubmit() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this10;
                that.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(valid, err) {
                    var loading, form, findRow, res, orderRes, msg, submitForm, item;
                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            if (!valid) {
                              _context12.next = 41;
                              break;
                            }

                            loading = _this10.$loading({
                              text: '订单提交中...',
                              spinner: 'el-icon-loading',
                              background: 'rgba(0, 0, 0, 0.7)'
                            });
                            _context12.prev = 2;
                            form = JSON.parse(JSON.stringify(that.form));
                            findRow = that.addressList.find(function (item) {
                              return item.ID === form.receiveAddressId;
                            });

                            if (findRow) {
                              form.receiveAddress = findRow.address;
                            } else {
                              form.receiveAddress = null;
                              form.receiveName = null;
                              form.contactInfo = null;
                            }

                            if (!form.id) {
                              _context12.next = 11;
                              break;
                            }

                            _context12.next = 9;
                            return updateSellOrder(form);

                          case 9:
                            _context12.next = 16;
                            break;

                          case 11:
                            _context12.next = 13;
                            return createSellOrder(form);

                          case 13:
                            res = _context12.sent;
                            that.form.id = res.ID;
                            form.id = res.ID;

                          case 16:
                            _context12.next = 18;
                            return that.productSaveAll();

                          case 18:
                            _context12.next = 20;
                            return that.loadDetail();

                          case 20:
                            _context12.next = 22;
                            return findSellOrder({
                              id: that.form.id
                            });

                          case 22:
                            orderRes = _context12.sent;

                            if (!orderRes.resellOrder.cashPledgeRatioWaring) {
                              _context12.next = 28;
                              break;
                            }

                            msg = '当前押金比例过低，无法提交订单<br>请联系相关人员增加押金';
                            that.$alert("<span style=\"color:#f00;\">".concat(msg, "</span>"), '提示信息', {
                              dangerouslyUseHTMLString: true,
                              center: true
                            });
                            _context12.next = 33;
                            break;

                          case 28:
                            // 提交订单
                            submitForm = {
                              id: that.form.id,
                              state: 7
                            };
                            _context12.next = 31;
                            return updateSellOrderState(submitForm);

                          case 31:
                            // 刷新明细
                            that.$notify.success('提交成功');
                            that.formEdit();

                          case 33:
                            _context12.next = 38;
                            break;

                          case 35:
                            _context12.prev = 35;
                            _context12.t0 = _context12["catch"](2);
                            console.log(_context12.t0.message);

                          case 38:
                            loading.close();
                            _context12.next = 48;
                            break;

                          case 41:
                            _context12.t1 = regeneratorRuntime.keys(err);

                          case 42:
                            if ((_context12.t2 = _context12.t1()).done) {
                              _context12.next = 48;
                              break;
                            }

                            item = _context12.t2.value;

                            _this10.$message.error(err[item][0].message);

                            return _context12.abrupt("return");

                          case 48:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, null, [[2, 35]]);
                  }));

                  return function (_x4, _x5) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    unFormSubmit: function unFormSubmit() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var that;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                that = _this11;
                that.$confirm('确定要撤回吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                  var loading, form;
                  return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          loading = _this11.$loading({
                            text: '订单撤回中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                          });
                          _context14.prev = 1;
                          form = {
                            id: that.form.id,
                            state: 10
                          };
                          _context14.next = 5;
                          return updateSellOrderState(form);

                        case 5:
                          that.formEdit();
                          _context14.next = 10;
                          break;

                        case 8:
                          _context14.prev = 8;
                          _context14.t0 = _context14["catch"](1);

                        case 10:
                          loading.close();

                        case 11:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, null, [[1, 8]]);
                })));

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    productSaveAll: function productSaveAll() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var that;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                that = _this12;
                return _context16.abrupt("return", new Promise(function (resolve, reject) {
                  var saveRows = that.detailList.filter(function (item) {
                    return !item.ID;
                  });

                  if (saveRows.length > 0) {
                    var form = {
                      createBase: [],
                      sellOrderId: that.form.id
                    };
                    saveRows.map(function (row) {
                      form.createBase.push({
                        sellQuantity: Number(row.sellQuantity),
                        sellUnitPrice: Number(row.sellUnitPrice),
                        sellAmount: Number((Number(row.sellQuantity) * Number(row.sellUnitPrice)).toFixed(2)),
                        remarks: null,
                        specsId: Number(row.specsId)
                      });
                    });
                    createSellOrderDetails(form).then(function (res) {
                      resolve('SUCCESS');
                    }).catch(function (e) {
                      reject(new Error(e.message));
                    });
                  } else {
                    resolve('SUCCESS');
                  }
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }))();
    },
    productRemove: function productRemove() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var that, row, index;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                that = _this13;
                _context17.prev = 1;

                if (!(that.detailRowIndex >= 0)) {
                  _context17.next = 14;
                  break;
                }

                row = that.detailList[that.detailRowIndex];
                index = that.detailList.indexOf(row);

                if (!row.ID) {
                  _context17.next = 8;
                  break;
                }

                _context17.next = 8;
                return deleteSellOrderDetail({
                  ID: row.ID
                });

              case 8:
                that.detailList.splice(index, 1);

                if (that.detailList.length < 1) {
                  that.detailForm.page = that.detailForm.page - 1;

                  if (that.detailForm.page < 1) {
                    that.detailForm.page = 1;
                  }
                }

                _context17.next = 12;
                return that.loadDetail();

              case 12:
                console.log('加载完成', that.detailList.length);
                that.$nextTick(function () {
                  if (that.detailList.length > 0) {
                    if (that.detailRowIndex > that.detailList.length - 1) {
                      that.detailRowIndex = that.detailList.length - 1;
                    }

                    var currentRow = that.detailList[that.detailRowIndex];
                    that.$refs.dataTableRef.setCurrentRow(currentRow, true);
                  } else {
                    that.detailRowIndex = -1;
                  }
                });

              case 14:
                _context17.next = 18;
                break;

              case 16:
                _context17.prev = 16;
                _context17.t0 = _context17["catch"](1);

              case 18:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[1, 16]]);
      }))();
    },
    addProduct: function addProduct() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var that;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                that = _this14;

                if (that.form.distributorId) {
                  _context18.next = 4;
                  break;
                }

                that.$message.error('请选择经销商');
                return _context18.abrupt("return");

              case 4:
                if (that.form.subsidiaryName) {
                  _context18.next = 7;
                  break;
                }

                that.$message.error('请选择供应商');
                return _context18.abrupt("return");

              case 7:
                if (that.form.receiveAddress) {
                  _context18.next = 10;
                  break;
                }

                that.$message.error('请选择收货地址');
                return _context18.abrupt("return");

              case 10:
                _context18.next = 12;
                return that.formStorage();

              case 12:
                that.$refs.ProductComponentRef.init({
                  distributorId: that.form.distributorId,
                  barCode: null,
                  consignmentPriceShow: false
                });

              case 13:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }))();
    },
    // 添加产品到detailList列表中
    addProductToDetailList: function addProductToDetailList(rows) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var that, repeat, newNum;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                that = _this15;

                if (!(rows.length === 0)) {
                  _context19.next = 4;
                  break;
                }

                that.$message.error('未选择要添加的产品');
                return _context19.abrupt("return");

              case 4:
                repeat = '';
                newNum = 0;
                rows.map(function (item) {
                  item.sellUnitPrice = item.wholesalePrice;
                  item.sellAmount = Number((item.sellQuantity * item.sellUnitPrice).toFixed(2));
                  var findRow = that.detailList.find(function (item2) {
                    return item.specsId === item2.specsId;
                  });

                  if (!findRow) {
                    that.detailList.push(item);
                    newNum += 1;
                  } else {
                    findRow.sellQuantity += Number(item.sellQuantity);
                    that.productSaveOne(findRow);
                    repeat += '<br>产品：' + findRow.productName + '，规格型号：' + findRow.specificationModel + '，数量+' + item.sellQuantity;
                  }
                });
                that.$notify({
                  type: 'success',
                  dangerouslyUseHTMLString: true,
                  message: '新增' + newNum + '个产品' + repeat
                });
                that.detailForm.total = that.detailList.length;

                if (!that.form.id) {
                  _context19.next = 14;
                  break;
                }

                _context19.next = 12;
                return that.productSaveAll();

              case 12:
                _context19.next = 14;
                return that.loadDetail();

              case 14:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }))();
    },
    productSaveOne: function productSaveOne(row) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var that, form, query;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                that = _this16;
                row.sellAmount = Number((Number(row.sellQuantity) * Number(row.sellUnitPrice)).toFixed(2));

                if (!that.form.id) {
                  _context20.next = 14;
                  break;
                }

                _context20.prev = 3;
                form = {
                  id: row.ID,
                  sellOrderId: Number(that.form.id),
                  sellQuantity: Number(row.sellQuantity),
                  sellUnitPrice: Number(row.sellUnitPrice),
                  sellAmount: row.sellAmount,
                  remarks: row.remarks,
                  specsId: row.specsId
                };
                _context20.next = 7;
                return updateSellOrderDetail(form);

              case 7:
                _context20.next = 14;
                break;

              case 9:
                _context20.prev = 9;
                _context20.t0 = _context20["catch"](3);
                // 更新失败，查询原数据恢复
                query = {
                  id: row.ID
                };
                _context20.next = 14;
                return findSellOrderDetail(query).then(function (res) {
                  var remoteRow = res.reagentSellOrderDetail;
                  row.sellQuantity = remoteRow.sellQuantity;
                  row.remarks = remoteRow.remarks;
                });

              case 14:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[3, 9]]);
      }))();
    },
    distributorIdChange: function distributorIdChange(row) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var that, findRow;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                that = _this17;
                that.form.receiveAddressId = null;
                that.form.receiveAddress = null;
                that.form.receiveName = null;
                that.form.contactInfo = null;
                that.form.subsidiaryName = null;
                _context21.next = 8;
                return that.loadAddress();

              case 8:
                that.subsidiaryList = [];
                findRow = that.manufacturerList.find(function (item) {
                  return item.ID === that.form.distributorId;
                });

                if (findRow) {
                  that.subsidiaryList = findRow.subsidiarys ? findRow.subsidiarys : [];
                }

                if (that.subsidiaryList.length === 0) {
                  that.form.subsidiaryName = that.$store.state.d2admin.user.info.organizationName;
                } else {
                  that.form.subsidiaryName = null;
                }

                _context21.next = 14;
                return that.loadDealerUserManu();

              case 14:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }))();
    },
    addressChange: function addressChange(val) {
      var that = this;

      if (val) {
        var findRow = that.addressList.find(function (item) {
          return item.ID === that.form.receiveAddressId;
        });

        if (findRow) {
          that.form.receiveAddress = findRow.address;
          that.form.receiveName = findRow.contactPerson;
          that.form.contactInfo = findRow.mobile;
        } else {
          that.form.receiveAddress = null;
          that.form.receiveName = null;
          that.form.contactInfo = null;
        }
      }
    },
    orderInvalid: function orderInvalid() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var that;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                that = _this18;
                that.$confirm('确定要作废吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                  var form;
                  return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                      switch (_context22.prev = _context22.next) {
                        case 0:
                          form = {
                            id: that.form.id,
                            state: 5
                          };
                          updateSellOrderState(form).then(function () {
                            that.$notify.success('订单作废成功');
                            that.returnList();
                          });

                        case 2:
                        case "end":
                          return _context22.stop();
                      }
                    }
                  }, _callee22);
                }))).catch(function () {});

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }))();
    },
    orderDelete: function orderDelete() {
      var that = this;
      that.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var form;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                form = {
                  ID: that.form.id
                };
                deleteSellOrder(form).then(function () {
                  that.$notify.success('订单删除成功');
                  that.returnList();
                });

              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }))).catch(function () {});
    },
    returnList: function returnList() {
      var that = this;
      that.$store.dispatch('d2admin/page/close', {
        tagName: that.$route.fullPath
      });
      that.$router.push({
        path: '/order/consign'
      });
    },
    tabChange: function tabChange(val) {
      var that = this;
      that.tabActiveId = val;

      if (val === 1) {
        this.detailTableCacheName = 'SC-' + this.$route.name + '-detail-table';
        that.loadDetail();
      } else {
        this.detailTableCacheName = 'SC-' + this.$route.name + '-delivery-table';
        that.loadStockout();
      }

      that.timestamp = new Date().valueOf();
    },
    loadStockout: function loadStockout() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var that;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                that = _this19;
                that.stockoutList = [];
                _context25.next = 4;
                return listStockOutOrder({
                  page: that.stockForm.page,
                  pageSize: that.stockForm.pageSize,
                  sellOrderId: that.form.id,
                  issueType: 3,
                  statusArr: [6]
                }).then(function (res) {
                  res.list.map(function (row) {
                    row.deliveryTime = dayjs(row.deliveryTime).format('YYYY-MM-DD');
                    row.detailList = row.stockoutInfo;
                  });
                  that.stockoutList = res.list;
                  that.stockForm.total = res.total;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }))();
    },
    stockoutStatusFormatter: function stockoutStatusFormatter(val) {
      var that = this;
      var findRow = that.stockoutStatusList.find(function (item) {
        return item.ID === val;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return val;
      }
    },
    detailRowKey: function detailRowKey(row, name) {
      var key = this.$route.name + (name || '') + row.__ob__.dep.id;
      return key;
    },
    orderOutPrint: function orderOutPrint() {
      var that = this;
      that.$refs.PrintOutComponentRef.init(that.form.id);
    },
    selectionChange: function selectionChange() {
      var that = this;
      that.selectionRows = that.$refs.deliveryListTableRef.selection;
    },
    selectable: function selectable(row) {
      if (row.status === 4) {
        return true;
      } else {
        return false;
      }
    },
    stockPageChange: function stockPageChange(page) {
      var that = this;
      that.stockForm.page = page;
      that.loadStockout();
    }
  })
};